import { T_LocationAddress } from "./Models_Location";

export const T_ExternalLocationModel = {
	address: T_LocationAddress,
	description: [],
	image: null,
	name: '',
};
